import axiosInstance from '@/store/axios';

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    upload({ commit }, file) {
      const headers = {
        'Content-Type': 'multipart/form-data',
      };
      return axiosInstance.post('/api/v1/upload', file, {
        headers,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error));
    },
  },
};
